<template>
  <div class="approval">
    <!-- 未审批飞行活动 -->
    <BasicTable
    :isStyleApplied="isStyleApplied"
      :tableColumn="tableColumn_1"
      :tableData="approvalList"
      :tableTitle="tableTitle_1"
      :showSearch="true"
      :showAddButton="false"
      searchPlaceholder="型号,执照号,运营人,驾驶员,起/降点,空域,航线,备注"
      :isPart="true"
      :hasAddBtn="false"
      ref="approvalList"
      :current="current"
      :total="total"
      :size="size"
      @search-item="searchItem1"
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
    >
      <template #customCol>
        <el-table-column prop="type" label="任务类型" align="center" min-width="60" :show-overflow-tooltip="true">
          <template slot-scope="scope">
            <span v-if="scope.row.type == 0">观光</span>
            <span v-else-if="scope.row.type == 1">巡检</span>
            <span v-else-if="scope.row.type == 2">物流</span>
            <span v-else-if="scope.row.type == 3">应急</span>
          </template>
        </el-table-column>
        <el-table-column
          prop="status"
          label="状态"
          align="center"
          min-width="60"
          :show-overflow-tooltip="true"
        >
          <template slot-scope="scope">
            <span v-if="scope.row.category === 2">报备飞行活动</span>
            <span v-else-if="scope.row.status === 0">待审批</span>
            <span v-if="scope.row.status === 3">放飞申请</span>
            <span v-if="scope.row.status === 5">进场申请</span>
            <span v-if="scope.row.status === 8">执飞申请</span>
            <span v-if="scope.row.status === 11">降落申请</span>
          </template>
        </el-table-column>
        <!-- <el-table-column
            prop="planSerial"
            label="活动编号"
            align="center"
            min-width="60"
            :show-overflow-tooltip="true"
          >
          </el-table-column> -->
        <el-table-column
          prop="note"
          label="备注"
          align="center"
          min-width="60"
          :show-overflow-tooltip="true"
        >
        </el-table-column>

      </template>
      <!-- customBtn自定义操作列 -->
      <template #customBtn>
        <el-table-column
          label="操作"
          align="center"
          min-width="120"
        >
          <template slot-scope="scope">
            <el-button v-if="scope.row.category !== 2&&scope.row.status===0&&uBtnPermissionList.includes('approval')" @click="approvalClick(scope.row)" type="text" size="small">审批</el-button>
            <el-button v-if="scope.row.category !== 2&&scope.row.status===3&&uBtnPermissionList.includes('approvalFly')" @click="approvalClick(scope.row)" type="text" size="small">放飞申请批准</el-button>
            <el-button v-if="scope.row.category !== 2&&scope.row.status===5&&uBtnPermissionList.includes('approvalEnter')" @click="approvalClick(scope.row)" type="text" size="small">允许进场</el-button>
            <el-button v-if="scope.row.category !== 2&&scope.row.status===8&&uBtnPermissionList.includes('approvalTakeOff')" @click="approvalClick(scope.row)" type="text" size="small">允许起飞</el-button>
            <el-button v-if="scope.row.category !== 2&&scope.row.status===11&&uBtnPermissionList.includes('approvalLand')" @click="approvalClick(scope.row)" type="text" size="small">允许降落</el-button>

            <!-- 是否有驳回原因 -->
            <el-button v-if="scope.row.category !== 2&&scope.row.status===0&&uBtnPermissionList.includes('reject')" @click="rejectClick(scope.row)" type="text" size="small">驳回</el-button>
            <el-button @click="handlePreview(scope.row)"  type="text" size="small">查看</el-button>
          </template>
        </el-table-column>
      </template>
    </BasicTable>
    <!-- 已审批飞行活动 -->
    <BasicTable
      :isStyleApplied="isStyleApplied"
      :tableColumn="tableColumn_2"
      :tableData="approvalCompletedList"
      :tableTitle="tableTitle_2"
      :isPart="true"
      ref="approvalCompletedList"
      :showSearch="true"
      searchPlaceholder="型号,执照号,运营人,驾驶员,起/降点,空域,航线,备注"
      :hasAddBtn="false"
      :current="currentApproved"
      :total="totalApproved"
      :size="sizeApproved"
      @search-item="searchItem2"
      @size-change="handleSizeChange_approved"
      @current-change="handleCurrentChange_approved"
    >
      <template #customCol>
        <el-table-column prop="type" label="任务类型" align="center" min-width="60" :show-overflow-tooltip="true">
          <template slot-scope="scope">
            <span v-if="scope.row.type == 0">观光</span>
            <span v-else-if="scope.row.type == 1">巡检</span>
            <span v-else-if="scope.row.type == 2">物流</span>
            <span v-else-if="scope.row.type == 3">应急</span>
          </template>
        </el-table-column>
        <el-table-column
          prop="status"
          label="状态"
          align="center"
          min-width="60"
          :show-overflow-tooltip="true"
        >
          <template slot-scope="scope">
            <span v-if="scope.row.category === 2">报备飞行活动</span>
            <span v-if="scope.row.status === 2">已审批</span>
            <span v-if="scope.row.status === 4">放飞申请通过</span>
            <span v-if="scope.row.status === 6">进场申请通过</span>
            <span v-if="scope.row.status === 9">执飞申请通过</span>
            <span v-if="scope.row.status === 12">降落申请通过</span>

          </template>
        </el-table-column>
        <!-- <el-table-column
            prop="planSerial"
            label="活动编号"
            align="center"
            min-width="60"
            :show-overflow-tooltip="true"
          >
        </el-table-column> -->
        <el-table-column
          prop="note"
          label="备注"
          align="center"
          min-width="60"
          :show-overflow-tooltip="true"
        >
        </el-table-column>
      </template>
      <template #customBtn>
        <el-table-column
          label="操作"
          align="center"
          min-width="80"
        >
          <template slot-scope="scope">
            <span>
              <el-button @click="handlePreview(scope.row)"  type="text" size="small">查看</el-button>
            </span>
          </template>
        </el-table-column>
      </template>
    </BasicTable>

    <BasicForm
      :isStyleApplied="isStyleApplied"
      :dialogVisible="clickButton"
      :dialogTitle=dialogTitle
      :formModel="taskForm"
      :btnName="btnName"
      @submit="submitApproval"
      @update:dialogVisible="updateDialogVisible"
      :formRules="formRules"
    >
      <el-col :span="12">
        <el-form-item label="飞机序列号" prop="uavSerial">
          <el-input
            class="formInputClass"
            maxlength="200"
            v-model="taskForm.uavSerial"
            :disabled="true"
          >
          </el-input
          >
        </el-form-item>
      </el-col>
      <el-col :span="12">
        <el-form-item label="飞机型号" prop="uavModel">
          <el-input
            class="formInputClass"
            maxlength="200"
            v-model="taskForm.uavModel"
            :disabled="true"
          >
          </el-input
          >
        </el-form-item>
      </el-col>
      <el-col :span="12">
        <el-form-item label="驾驶员执照号" prop="pilotLicense">
          <el-input
            class="formInputClass"
            placeholder="请填写驾驶员执照号"
            maxlength="200"
            v-model="taskForm.pilotLicense"
            :disabled="true"
          >
          </el-input
          >
        </el-form-item>
      </el-col>
      <el-col :span="12">
        <el-form-item label="驾驶员名称" prop="pilot">
          <el-input
            class="formInputClass"
            maxlength="200"
            v-model="taskForm.pilot"
            :disabled="true"
          >
          </el-input
          >
        </el-form-item>
      </el-col>
      <!-- <el-col :span="12">
        <el-form-item label="运营人名称" prop="operatorName">
          <el-input
            class="formInputClass"
            maxlength="200"
            v-model="taskForm.operatorName"
            :disabled="true"
          >
          </el-input
        ></el-form-item>
      </el-col> -->
      <!-- <el-col :span="12">
        <el-form-item label="运营人编号" prop="operatorNum">
          <el-input
            class="formInputClass"
            maxlength="200"
            v-model="taskForm.operatorNum"
            :disabled="true"
          >
          </el-input
        ></el-form-item>
      </el-col> -->
      <el-col :span="12">
        <el-form-item label="运营人执照号" prop="operatorLicense">
          <el-input
            class="formInputClass"
            maxlength="200"
            v-model="taskForm.operatorLicense"
            :disabled="true"
          >
          </el-input
          >
        </el-form-item>
      </el-col>
      <el-col :span="12">
        <el-form-item label="运营人名称" prop="operatorName">
          <el-input
            class="formInputClass"
            placeholder="请填写运营人名称"
            maxlength="200"
            v-model="taskForm.operatorName"
            :disabled="true"
          >
          </el-input
          >
        </el-form-item>
      </el-col>
      <el-col :span="12">
        <el-form-item label="起飞点" prop="startPoint">
          <el-input
            class="formInputClass"
            maxlength="200"
            v-model="taskForm.startPoint"
            :disabled="true"
          >
          </el-input>
        </el-form-item>
      </el-col>
      <el-col :span="12">
        <el-form-item label="降落点" prop="endPoint">
          <el-input
            class="formInputClass"
            maxlength="200"
            v-model="taskForm.endPoint"
            :disabled="true"
          >
          </el-input>
        </el-form-item>
      </el-col>
      <el-col :span="12">
        <el-form-item label="起飞时间" prop="startTime">
          <el-date-picker
            v-model="taskForm.startTime"
            type="datetime"
            placeholder="请填写起飞时间"
            :disabled="true"
          >
          </el-date-picker>
        </el-form-item>
      </el-col>
      <el-col :span="12">
        <el-form-item label="降落时间" prop="endTime">
          <el-date-picker
            placeholder="请填写降落时间"
            v-model="taskForm.endTime"
            type="datetime"
            :disabled="true"
          >
          </el-date-picker>
        </el-form-item>
      </el-col>
      <el-col :span="12">
        <el-form-item label="航线信息" prop="routeName">
          <el-input
            class="formInputClass"
            maxlength="200"
            v-model="taskForm.routeName"
            :disabled="true"
          >
          </el-input>
        </el-form-item>
      </el-col>
      <el-col :span="12">
        <el-form-item label="任务类型" prop="type">
          <el-select v-model="taskForm.type" placeholder="请选择任务类型" popper-class="adminHomeSelect" :disabled="true">
            <el-option v-for="type in typeList" :key="type.id" :label="type.name" :value="type.id"></el-option>
          </el-select>
        </el-form-item>
      </el-col>
      <el-row>
        <el-col :span="12">
          <el-form-item label="空域信息" prop="spaceId" v-if="showSpace">
            <el-input
              class="formInputClass"
              maxlength="200"
              v-model="taskForm.spaceName"
              :disabled="true"
            >
            </el-input>
            <!--            <el-select v-model="taskForm.spaceId" placeholder="请选择空域信息" popper-class="adminHomeSelect" :disabled="true">-->
            <!--              <el-option v-for="space in spaces" :key="space.spaceId" :label="space.spaceName" :value="space.spaceId"></el-option>-->
            <!--            </el-select>-->
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="飞行高度" prop="height" v-if="showSpace">
            <el-input class="formInputClass" placeholder="请填写飞行高度" maxlength="200" v-model="taskForm.height" :disabled="true" />
          </el-form-item>
        </el-col>
      </el-row>
      <!-- <el-col :span="12">
        <el-form-item label="活动编号" prop="planSerial">
          <el-input
            class="formInputClass"
            maxlength="200"
            v-model="taskForm.planSerial"
            :disabled="true"
          >
          </el-input
        ></el-form-item>
      </el-col> -->
      <el-col :span="12">
        <el-form-item label="备注" prop="note">
          <el-input
            class="formInputClass"
            maxlength="200"
            v-model="taskForm.note"
            :disabled="true"
          >
          </el-input
          >
        </el-form-item>
      </el-col>
    </BasicForm>
    <!-- 驳回 -->
    <BasicForm
      :isStyleApplied="isStyleApplied"
      :dialogVisible="rejectButton"
      :dialogTitle=dialogTitle
      :btnName="btnName"
      :formModel="rejectForm"
      @submit="rejectApproval"
      @update:dialogVisible="updateRejectDialogVisible"
      :formRules="formRules"
    >
      <el-col :span="20">
        <el-form-item label="驳回原因" prop="reason">
          <el-input
            type="textarea"
            :rows="5"
            class="formInputClass"
            maxlength="200"
            v-model="rejectForm.reason"
            placeholder="请填写驳回原因"
          >
          </el-input
          >
        </el-form-item>
      </el-col>
      <el-col :span="12">
        <el-form-item label="" prop="id" hidden>
          <el-input
            class="formInputClass"
            maxlength="200"
            v-model="rejectForm.id"
            :disabled="true"
          >
          </el-input
          >
        </el-form-item>

      </el-col>
    </BasicForm>


  </div>
</template>
<script type="text/javascript">
import BasicTable from "../../common/BasicTable.vue";
import BasicForm from "../../common/BasicForm.vue";

export default {
   props: {
    isStyleApplied: {
      type: Boolean,
      default: false,
    },
  },
  name: "ApprovalManagement",

  components: {
    BasicTable, //公共表格
    BasicForm, //公共弹框
  },

  data() {
    return {
      clickButton: false,
      rejectButton: false,
      itemList: [],
      itemCompletedList: [],
      spaces: [],
      approvalList: [],
      approvalCompletedList: [],
      rejectForm:{id:'',note:''},
      // 审批详情信息
      taskForm: {
        planSerial: "",
        uavSerial: "",
        uavModel: "",
        pilot: "",
        operatorName: "",
        operatorNum: "",
        operatorLicense: "",
        startPointId: "",
        startPoint: {
          name: '起飞点',
        },
        endPointId: "",
        endPoint: {
          name: '降落点',
        },
        startTime: "",
        endTime: "",
        routeId: "",
        spaceId: "",
        height: "",
        type: "",
        note: "",
      },
      // 未审批飞行活动
      tableColumn_1: [
        {label: "飞机序列号", prop: "uavSerial"},
        {label: "飞机型号", prop: "uavModel"},
        // {label: "驾驶员执照号", prop: "pilotLicense"},
        {label: "驾驶员名称", prop: "pilot"},
        // { label: "运营人编号", prop: "operatorNum" },
        // {label: "运营人执照号", prop: "operatorLicense"},
        {label: "运营人名称", prop: "operatorName"},
        {label: "起飞点", prop: "startPoint"},
        {label: "起飞时间", prop: "startTime"},
        {label: "降落点", prop: "endPoint"},
        {label: "降落时间", prop: "endTime"},
        {label: "航线信息", prop: "routeName"},
        //{label: "任务类型", prop: "type"},
        {label: "空域信息", prop: "spaceName"},
        {label: "飞行高度", prop: "height"},
        // { label: "状态", prop: "status" },
        // { label: "活动编号", prop: "planSerial" },
        // { label: "备注", prop: "note" },
      ],
      // 已审批飞行活动
      tableColumn_2: [
        {label: "飞机序列号", prop: "uavSerial"},
        {label: "飞机型号", prop: "uavModel"},
        // {label: "驾驶员执照号", prop: "pilotLicense"},
        {label: "驾驶员名称", prop: "pilot"},
        // { label: "运营人编号", prop: "operatorNum" },
        // {label: "运营人执照号", prop: "operatorLicense"},
        {label: "运营人名称", prop: "operatorName"},
        {label: "起飞点", prop: "startPoint"},
        {label: "起飞时间", prop: "startTime"},
        {label: "降落点", prop: "endPoint"},
        {label: "降落时间", prop: "endTime"},
        {label: "航线信息", prop: "routeName"},
        {label: "空域信息", prop: "spaceName"},
        {label: "飞行高度", prop: "height"},
        //{label: "任务类型", prop: "type"},
        // { label: "状态", prop: "status" },
        // { label: "活动编号", prop: "planSerial" },
        // { label: "备注", prop: "note" },
      ],
      tableTitle_1: '未审批飞行活动', //表格标题
      tableTitle_2: '已审批飞行活动',
      dialogTitle: '',
      btnName: '',
      // 定义表单必填校验
      formRules: [
        // { label: '活动编号', prop: 'planSerial' },
        {label: '飞机序列号', prop: 'uavSerial'},
        {label: '飞机型号', prop: 'uavModel'},
        {label: '驾驶员执照号', prop: 'pilotLicense'},
        {label: '驾驶员名称', prop: 'pilot'},
        {label: '运营人执照号', prop: 'operatorLicense'},
        {label: '运营人名称', prop: 'operatorName'},
        {label: '起飞点', prop: 'startPoint.name'},
        {label: '降落点', prop: 'endPoint.name'},
        {label: '起飞时间', prop: 'startTime'},
        {label: '降落时间', prop: 'endTime'},
        //{label: '任务类型', prop: 'type'},
        //{label: '航线信息', prop: 'routeName'},
        {label: '驳回原因', prop: 'reason'},
      ],
      total: 0, //总条数
      current: 1, //当前页数
      size: 6, //显示几条
      totalApproved: 0, //已审批计划列表总条数
      currentApproved: 1, //已审批计划列表当前页数
      sizeApproved: 6, //已审批计划列表显示几条
      typeList: [
        { id: 0, name: "观光" },
        { id: 1, name: "巡检" },
        { id: 2, name: "物流" },
        { id: 3, name: "应急" }
      ],
      showSpace: false,
      searchKey1: '', //未审批搜索关键字
      searchKey2: '',  //已审批搜索关键字
    };
  },
  computed:{
    uBtnPermissionList() {
      return  this.getPageBtnRole('approvalManagement')||[]
    },
  },
  methods: {
    // 关闭对话框时获取子组件传过来的状态
    updateDialogVisible(newVal) {
      this.clickButton = newVal;
    },
    updateRejectDialogVisible(newVal) {
      this.rejectButton = newVal;
    },
    //分页函数
    handleSizeChange: function (size) {
      this.size = size;
      this.unApprovedPlan();
    },
    handleCurrentChange: function (current) {
      this.current = current;
      this.unApprovedPlan();
    },
    handleSizeChange_approved: function (size) {
      this.sizeApproved = size;
      this.approvedPlan();
    },
    handleCurrentChange_approved: function (current) {
      this.currentApproved = current;
      this.approvedPlan();
    },
    tableRowClassName({row, rowIndex}) {
      if (this.openedId === row.id) {
        return "focusRowStyle";
      }
      return "rowStyle";
    },
    changeCellStyle(row, column, rowIndex, columnIndex) {
      if (row.column.label === "优先级") {
        return "color:#FFA63E;padding: 0;"; //修改的样式
      } else {
        return "color:#FFFFFF;padding: 0;";
      }
    },
    //    submit(type) {
    //   if ("pass" === type) {
    //     this.flight.flight_status = 40;
    //     this.updateApproved();
    //   } else {
    //     let note = this.flight.note;
    //     if (note) {
    //       this.flight.flight_status = 31;
    //       this.updateApproved();
    //     } else {
    //       let tips =
    //         "<i class='el-icon-warn-tip'></i>驳回时,需要填写备注哦~";
    //       this.$confirm(tips, "", {
    //         confirmButtonText: "好的",
    //         customClass: "confirmClass-style",
    //         iconClass: "",
    //         confirmButtonClass: "confirm",
    //         dangerouslyUseHTMLString: true,
    //         showCancelButton: false,
    //       });
    //     }
    //   }
    // },

// getApproved(){
//    this.getRequest(
//          "/uav-task-server/plandto/queryPlanDtoByCondition"
//       ).then((res) => {
//         let oData = res.data;
//           let planData = oData.data;
//           for (let i = 0, len = planData.length; i < len; i++)
//           {
//             if ((0 === planData[i].status) && !this.itemList.includes(planData[i].id)) {
//               this.approvalList.push(planData[i]);
//               this.itemList.push(planData[i].id);
//             }
//             else if ((1 === planData[i].status) && !this.itemCompletedList.includes(planData[i].id)) {
//               this.approvalCompletedList.push(planData[i]);
//               this.itemCompletedList.push(planData[i].id);
//             }
//           }
//       });
//     },

    unApprovedPlan() {
      this.getRequest(`/uav-task-server/plandto/queryPlan?status=0&status=3&status=5&status=8&status=11&category=1&currentpage=${this.current}&pagesize=${this.size}&keyWord=${this.searchKey1}`)
        .then((res) => {
            let oData = res.data;
            if (0 == oData.code) {
              if (oData.data) {
                this.approvalList = oData.data.list;
                this.total = oData.data.total;
                this.current = oData.data.pageNum;
              } else {
                this.approvalList = [];
              }
            }
          }
        );
    },
    approvedPlan() {
      this.getRequest(`/uav-task-server/plandto/queryPlan?status=2&status=4&status=6&status=9&&currentpage=${this.currentApproved}&pagesize=${this.sizeApproved}&keyWord=${this.searchKey2}`)
        .then((res) => {
            let oData = res.data;
            if (0 == oData.code) {
              if (oData.data) {
                this.approvalCompletedList = oData.data.list;
                this.totalApproved = oData.data.total;
                this.currentApproved = oData.data.pageNum;
              } else {
                this.approvalCompletedList = [];
              }
            }
          }
        );
    },
    // getApproved() {
    //   this.getRequest(
    //      "/uav-task-server/plandto/queryPlanDtoByCondition?status=0"
    //   ).then((res) => {
    //     let oData = res.data;
    //     let planData = oData.data;
    //     console.log('oData---', oData);
    //     if (planData) {
    //       this.approvalList = planData;
    //     } else {
    //       this.approvalList = [];
    //     }
    //   });
    // },
    // getCompletedApproved() {
    //   this.getRequest(
    //      "/uav-task-server/plandto/queryPlanDtoByCondition?status=1"
    //   ).then((res) => {
    //     let oData = res.data;
    //       let planData = oData.data;
    //     if (planData) {
    //       this.approvalCompletedList = planData;
    //       } else {
    //         this.approvalCompletedList = [];
    //       }
    //   });
    // },
    updateApproved(param) {
      this.getRequest(
        "/uav-task-server/plan/approvePlan?id=" + param.id
      ).then((res) => {
        let oData = res.data;
        if (oData.code === 0) {
          this.clickButton = false;
          this.$message({
            message: oData.msg,
            duration: 1000,
            customClass: "message-s",
            iconClass: "el-icon-ok-tip",
            offset: 470,
            onClose: function () {
            },
          });
          this.unApprovedPlan();
          this.approvedPlan();
        } else if (oData.code != 401) {
          this.$message.error({
            message: oData.msg,
            duration: 1000,
            customClass: "message-warn-s",
            iconClass: "el-icon-warn-tip",
            offset: 470,
            onClose: function () {
            }
          });
        }
      });
    },
    rejectPlan(param) {
      this.getRequest(
        "/uav-task-server/plan/refusePlanById?id=" + param.id+"&reason="+ param.reason
      ).then((res) => {
        let oData = res.data;
        if (oData.code === 0) {
          // const index = this.approvalList.findIndex(item => item.id === param.id);
          // if (index !== -1) {
          //   this.approvalList.splice(index, 1, param);
          // }
          this.$message({
            message: oData.msg,
            duration: 1000,
            customClass: "message-s",
            iconClass: "el-icon-ok-tip",
            offset: 470,
            onClose: function () {
            },
          });
          this.unApprovedPlan();
          this.approvedPlan();
        } else if (oData.code != 401) {
          this.$message.error({
            message: oData.msg,
            duration: 1000,
            customClass: "message-warn-s",
            iconClass: "el-icon-warn-tip",
            offset: 470,
            onClose: function () {
            }
          });
        }
      });
    },
    handlePreview(param) {
      // 打开审批详情
      this.clickButton = true;
      this.taskForm = {...param};
      this.dialogTitle = "飞行活动查看";
      this.btnName = "关闭";
      if (param.routeId === null){
        this.showSpace = true;
      }else {
        this.showSpace = false;
      }
    },
    approvalClick(param) {
      // 打开审批详情
      this.clickButton = true;
      this.taskForm = {...param};
      this.dialogTitle = "飞行活动审批";
      this.btnName = "审批";
      if (param.routeId === null){
        this.showSpace = true;
      }else {
        this.showSpace = false;
      }
    },
    rejectClick(param) {
      // 驳回
      this.rejectForm = {id: param.id};
      this.rejectButton = true;
      this.dialogTitle = "飞行活动驳回";
      this.btnName = "驳回";
    },
    // 提交审批
    submitApproval() {
      let params = {...this.taskForm};
      if (this.dialogTitle === "飞行活动审批") {
        this.updateApproved(params);
      }
      this.clickButton = false;
    },
    rejectApproval() {
      // let params = {...this.taskForm};
      let params = this.rejectForm;
      this.rejectPlan(params);
      this.rejectButton = false;
    },
    searchItem1(val) {
      //模糊搜索 未执行飞行活动
      this.searchKey1 = val;
      this.unApprovedPlan();
    },
    searchItem2(val) {
      //模糊搜索 已执行飞行活动
      this.searchKey2 = val;
      this.approvedPlan();
    },
  },
  mounted() {
    this.$nextTick(function () {
      this.unApprovedPlan();
      this.approvedPlan();
      //this.getConfirmRelationListByFlightApproved();
      //this.getConfirmRelationListByFlightApprovedCompleted();
    });
    // window.queryTimer = setInterval(
    //   this.queryAllCline,
    //   40
    // ); //4秒轮询一次
    //  window.queryTimer = setInterval(
    //   this.getApproved,
    //   40
    // ); //4秒轮询一次
     window.queryTimer = setInterval(()=>{this.unApprovedPlan();this.approvedPlan()},20000); //20秒轮询一次
  },
  beforeDestroy() {
    if (window.queryTimer) {
      clearInterval(window.queryTimer);
      window.queryTimer = null;
    }
  },
}
</script>

<style scoped>
/* .approval {
  margin-top: 63px;
} */
</style>




// WEBPACK FOOTER //
// src/components/home/ApprovalManagement.vue